// extracted by mini-css-extract-plugin
export default {"toggle":"lsf-toggle","toggle__input":"lsf-toggle__input","toggle__indicator":"lsf-toggle__indicator","toggle_checked":"lsf-toggle_checked","toggle_disabled":"lsf-toggle_disabled","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380243
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  